import gnnodexui from '@bumblehead/gani/src/gnnodexui.js'

import {
  gngraphNodeParentGet as graphNodeParentGet
} from '@bumblehead/gani/src/gngraph.js'

import {
  gnaccSubj as accSubj
} from '@bumblehead/gani/src/gnacc.js'

import {
  centerOriginToTopLeft,
  getnormalmaterial,
  latLonToVector3,
  xyToLatLon
} from './uithree.js'

import uicanvasstageseqaction from './uicanvasstageseqaction.js'

const isdarkmode = (win, doc = win.document) => (
  win.matchMedia && win.matchMedia('(prefers-color-scheme: dark)').matches)
  || doc.documentElement.getAttribute('data-darkreader-scheme') === 'dark'


const getmesh = (sess, cfg, graph, node) => (
  uicanvasstageseqaction.rafcfg(cfg, node).mesh)

const getposlatlon = (THREE, pos) => {
  const centerpos = centerOriginToTopLeft(THREE, pos[0], pos[1], 480, 200)

  return xyToLatLon(centerpos.x, centerpos.y, 480, 200)
}

const getCubeGeometry = THREE => {
  const cubeVertices = new Float32Array([
    // front
    -1, -1, 1, 1, -1, 1, -1, 1,  1,
    -1,  1, 1, 1, -1, 1,  1, 1,  1,
    // back
    1, -1, -1, -1, -1, -1,  1, 1, -1,
    1,  1, -1, -1, -1, -1, -1, 1, -1,
    // left
    -1, -1, -1, -1, -1, 1, -1, 1, -1,
    -1,  1, -1, -1, -1, 1, -1, 1,  1,
    // right
    1, -1, 1, 1, -1, -1, 1, 1,  1,
    1,  1, 1, 1, -1, -1, 1, 1, -1,
    // top
    1,  1, -1, -1, 1, -1,  1, 1, 1,
    1,  1,  1, -1, 1, -1, -1, 1, 1,
    // bottom
    1, -1,  1, -1, -1, 1,  1, -1, -1,
    1, -1, -1, -1, -1, 1, -1, -1, -1
  ].map(n => n * 44)) // size seems about right...
  const cubeGeometry = new THREE.BufferGeometry()

  cubeGeometry.setAttribute(
    'position', new THREE.BufferAttribute(cubeVertices, 3))

  return cubeGeometry
}

const addcollider = (THREE, mesh) => {
  const cubeGeometry = getCubeGeometry(THREE)
  // let collider = new THREE.Mesh(
  //   new THREE.CubeGeometry(100, 100, 100), o.getnormalmaterial())
  const collider = new THREE.Mesh(
    cubeGeometry, getnormalmaterial(THREE))

  collider.material.visible = false
  mesh.add(collider)
  mesh.collider = collider

  return mesh
}

const getshapemesh = (THREE, { rotation, position, color, shapetype }) => {
  const geometry = getCubeGeometry(THREE)
  const colorisdarkmode = isdarkmode(window)
  const colordefault = colorisdarkmode
    ? 'rgba(20, 55, 55, 1)'
    : 'rgba(255, 255, 140, 1)'
  const material = new THREE.MeshBasicMaterial({
    opacity: 0.96,
    transparent: true,
    color: shapetype === 'architectonic'
      ? colordefault
      : color
  })
  let mesh = new THREE.Mesh(geometry, material)

  Object.assign(mesh.position, {
    x: position[0],
    y: position[1],
    z: position[2]
  })

  Object.assign(mesh.rotation, {
    x: rotation[0],
    y: rotation[1],
    z: rotation[2]
  })

  if (shapetype !== 'architectonic')
    (mesh = addcollider(THREE, mesh))

  return mesh
}

// if no rafcfg will build one from subj
const xonattach = (ss, cfg, gr, nd, pg, rafcfg, subj) => {
  const pos = subj.pos
  let mesh = rafcfg.mesh
  const ndkey = nd.get('key')
  const latlon = getposlatlon(cfg.THREE, pos)
  const seqnode = graphNodeParentGet(gr, nd)
  const seqsub = accSubj.get(seqnode, {})

  if (!mesh) {
    mesh = getshapemesh(cfg.THREE, subj)
    rafcfg.mesh = mesh
  }

  mesh.position.copy(latLonToVector3(cfg.THREE, latlon, 128))
  // set the mesh nodekey for raycast purposes
  mesh.nodekey = ndkey

  if (mesh.collider)
    (mesh.collider.nodekey = ndkey)

  // mesh.visible = false
  mesh.visible = true
  // all major objects in three should be named for debugging
  mesh.name = `actionportal: ${seqsub.name}`
}

const setvisibility = (ss, cfg, gr, nd, prev, stagecfg, isvisible) => {
  const mesh = prev.mesh

  if (mesh && stagecfg.camera) {
    mesh.visible = isvisible
    mesh.lookAt(stagecfg.camera.position)
  }
}

const addtoscene = (ss, cfg, gr, nd, rafcfg, stagecfg) => {
  if (!rafcfg.mesh) {
    xonattach(ss, cfg, gr, nd, null, rafcfg, accSubj.get(nd))
  }

  const mesh = rafcfg.mesh
  const glscene = stagecfg.glscene

  if (mesh && glscene) {
    glscene.add(mesh)
    if (mesh.collider)
      glscene.colliders.push(mesh.collider)
  }
}

// throttled calls to update...
// const onsubj = (ss, cfg, gr, nd, prev, subj) => {
//   console.log('onsubj', subj)
//   const pos = subj.pus
//
//   if (rafcfg.mesh) {
//     rafcfg.mesh = uimesh.setposition(rafcfg.mesh, subj)
//
//     const latlon = xyToLatLon(pos[0], pos[1], 400, 200)
//
//     rafcfg.mesh.position.set(latLonToVector3(latlon, 128))
//   }
//
//   return true
// }

const setmeshopacity = (mesh, opacity) => {
  if (mesh && mesh.material) {
    mesh.material.opacity = opacity
  }
}

const onrayoverstart = (ss, cfg, gr, nd, prev, subj, stagecfg, mesh) => {
  mesh.material.opacity = 0.0
  mesh.parent.material.transparent = true
  mesh.parent.material.opacity = 0.80
  mesh.parent.material.color.set('rgb(255, 165, 0)')
}

const onrayoverend = (ss, cfg, gr, nd, prev, subj, stagecfg, mesh) => {
  mesh.parent.material.opacity = 1
  mesh.parent.material.color.set(
    subj.shapetype === 'architectonic'
      ? 'rgb(255, 255, 140)'
      : subj.color
  )
}

const onrayover = (ss, cfg, gr, nd, prev, subj, stagecfg) => {
  uicanvasstageseqaction.setstagecanvaselemcursor(stagecfg, 'pointer')
}

const onrayout = (ss, cfg, gr, nd, prev, subj, stagecfg) => {
  uicanvasstageseqaction.setstagecanvaselemcursor(stagecfg, 'auto')
}

const onactivate = (ss, cfg, gr, nd) => (
  gnnodexui.publishev(ss, cfg, nd, 'xonactivate'))

// should dest_scene be defined on sequence or action?
//
// sequence is used now..
const xonclick = (ss, cfg, gr, nd, prev) => (
  onactivate(ss, cfg, gr, nd, prev))

export default Object.assign({}, uicanvasstageseqaction, {
  type: 'uicanvasstageseqactionshape',
  getmesh,
  getposlatlon,
  getCubeGeometry,
  addcollider,
  getshapemesh,
  xonattach,
  setvisibility,
  addtoscene,
  setmeshopacity,
  onrayoverstart,
  onrayoverend,
  onrayover,
  onrayout,
  onactivate,
  xonclick
})
